module.exports = __webpack_public_path__ + "static/img/OlivierPotellet.d4841ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/OlivierPotellet.jpg
// module id = XtJL
// module chunks = 1